import {useState} from "react";
import {PopoverProps} from "../../types/types";

export default function Popover({
                                    children,
                                    content,
                                    position = "right",
                                    type = "hover",
                                    className = "",
                                    gap = '20px'
                                }: PopoverProps) {
    const [active, setActive] = useState(false)
    return children && <div
        onClick={() => {
            if (type == 'click') {
                setActive(!active)
            }
        }}
        className={`matchid-popover-box matchid-popover-${position} matchid-popover-${type} ${className} ${type == 'click' && active ? 'matchid-popover-click-active' : ''}`}>
        {children}
        <div style={{
            paddingTop: gap
        }} className={`matchid-popover-area`}>
            <div className={`matchid-popover-content`}>
                {content}
            </div>
        </div>
    </div>

}